/**
 * Convierte una URL pública a data URL (base64) para embeber en un PDF.
 * react-pdf fetchea las <Image src> y puede fallar por CORS; embeber como data URL lo evita.
 * Si la imagen no carga en 10 segundos o la respuesta no es 2xx, devuelve null. Nunca lanza, así
 * que el PDF se genera igual, sin esa imagen.
 */
export const urlToDataUrl = async (url: string | null | undefined): Promise<string | null> => {
  if (!url) return null
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 10_000)
  try {
    const res = await fetch(url, { signal: controller.signal })
    if (!res.ok) return null
    const blob = await res.blob()
    return await new Promise<string | null>((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(typeof reader.result === 'string' ? reader.result : null)
      reader.onerror = () => resolve(null)
      reader.readAsDataURL(blob)
    })
  } catch {
    return null
  } finally {
    clearTimeout(timeoutId)
  }
}
